import Vue from "vue";
import VueShowdownPlugin from "vue-showdown";

Vue.use(VueShowdownPlugin, { tables: true, smoothLivePreview: true });
